import React from 'react';
import { Box } from '@chakra-ui/react';
import AuroraBackground from './dashboard/AuroraBackground';
import PageHeader from './PageHeader';

// item 732 (Chad) — a BUCKET header for grouping project sections (e.g. "Project Management"
// wrapping Customer / Hand-offs / Documents / Links / Help Desks). Header-only + full-bleed like a
// section row; the grouped sections render beneath it (in a Collapse) at content width so their own
// full-bleed wrappers still work. Click anywhere on the bar to toggle the whole bucket.
const CollapsibleGroupHeader: React.FC<{
  title: string;
  subtitle?: React.ReactNode;
  icon?: React.ReactNode;
  collapse?: { collapsed: boolean; onToggle: () => void };
}> = ({
  title, subtitle, icon, collapse,
}) => {
  const collapsed = collapse?.collapsed ?? false;
  return (
    <Box
      position="relative"
      mx={{ base: -4, md: -10 }}
      px={{ base: 4, md: 10 }}
      pt={collapsed ? 1 : { base: 2, md: 3 }}
      pb={collapsed ? 1 : { base: 2, md: 3 }}
    >
      <AuroraBackground />
      {/* item 732 (Chad) — the bucket HEADER row goes BRAND RED when EXPANDED (it's the group's title
          bar); flat when collapsed. The gradient is passed to PageHeader's row so it isn't painted
          over by the default section-row panel. Uniform chevron owned by PageHeader. */}
      <Box position="relative" zIndex={1}>
        <PageHeader
          dense
          onTitleClick={collapse?.onToggle}
          collapsed={collapsed}
          rowGradient={collapsed ? undefined : 'linear(180deg, brand.500, brand.700)'}
          icon={icon}
          title={title}
          subtitle={subtitle}
        />
      </Box>
    </Box>
  );
};

CollapsibleGroupHeader.defaultProps = {
  subtitle: undefined,
  icon: undefined,
  collapse: undefined,
};

export default CollapsibleGroupHeader;
